import React from "react";

const flagStyle: React.CSSProperties = {
  overflow: "hidden",
  borderRadius: 3,
  boxShadow: "0 0 0 0.5px rgba(0,0,0,0.1)",
  verticalAlign: "middle",
  flexShrink: 0,
};

export const FlagUS: React.FC<{ size?: number }> = ({ size = 20 }) => (
  <svg width={size} height={size * 0.7} viewBox="0 0 60 42" style={flagStyle}>
    <rect width="60" height="42" fill="#B22234" />
    {[1, 3, 5, 7, 9, 11].map((i) => (
      <rect key={i} y={i * 3.23} width="60" height="3.23" fill="#FFF" />
    ))}
    <rect width="24" height="22.62" fill="#3C3B6E" />
    {[3.2, 7.6, 12, 16.4].map((cy) =>
      [2.4, 7.2, 12, 16.8, 21.6].map((cxVal) => (
        <circle key={`${cy}-${cxVal}`} cx={cxVal} cy={cy} r="1.2" fill="#FFF" />
      ))
    )}
    {[5.4, 9.8, 14.2].map((cy) =>
      [4.8, 9.6, 14.4, 19.2].map((cxVal) => (
        <circle key={`${cy}-${cxVal}`} cx={cxVal} cy={cy} r="1.2" fill="#FFF" />
      ))
    )}
  </svg>
);

export const FlagRU: React.FC<{ size?: number }> = ({ size = 20 }) => (
  <svg width={size} height={size * 0.7} viewBox="0 0 60 42" style={flagStyle}>
    <rect width="60" height="14" fill="#FFFFFF" />
    <rect y="14" width="60" height="14" fill="#0039A6" />
    <rect y="28" width="60" height="14" fill="#CE2D4F" />
  </svg>
);

export const FlagDE: React.FC<{ size?: number }> = ({ size = 20 }) => (
  <svg width={size} height={size * 0.7} viewBox="0 0 60 42" style={flagStyle}>
    <rect width="60" height="14" fill="#000000" />
    <rect y="14" width="60" height="14" fill="#DD0000" />
    <rect y="28" width="60" height="14" fill="#FFCC00" />
  </svg>
);

export const FlagUA: React.FC<{ size?: number }> = ({ size = 20 }) => (
  <svg width={size} height={size * 0.7} viewBox="0 0 60 42" style={flagStyle}>
    <rect width="60" height="21" fill="#0057B7" />
    <rect y="21" width="60" height="21" fill="#FFD700" />
  </svg>
);

export const FLAG_COMPONENTS: Record<string, React.FC<{ size?: number }>> = {
  en: FlagUS,
  ru: FlagRU,
  de: FlagDE,
  uk: FlagUA,
};
